import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { getUser, signIn as sendSignInRequest, ssoLoginOrRegister as ssoLoginOrRegisterRequest } from '../api/auth';


function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      if (!user) {
        const result = await getUser();
        if (result.isOk) {
          setUser(result.data);
        }
      }
      setLoading(false);
    })();
  }, [user]);

  const signIn = useCallback(async (email, password) => {
    const result = await sendSignInRequest(email, password);
    if (result.isOk) {
      setUser(result.data);
    }
    return result;
  }, []);

  const ssoLoginOrRegister = useCallback(async (ssoResponse) => {
    const result = await ssoLoginOrRegisterRequest(ssoResponse);
    if (result.isOk) {
      setUser(result.data);
    }
    return result;
  }, []);

  const signOut = useCallback(() => {
    setUser(undefined);
    window.localStorage.removeItem('token');
  }, []);


  return (
    <AuthContext.Provider value={{ user, signIn, ssoLoginOrRegister, signOut, loading }} {...props} />
  );
}

const AuthContext = createContext({ loading: false });
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth }
